'use client'

import { Button } from '@/components/ui/button'
import { ShopifyLogo, StripeLogo } from '@/components/ui/brand-logos'
import { BILLING_CHANNELS, type BillingChannel } from '@/lib/billing/constants'
import { cn } from '@/lib/utils'
import { useTranslations } from "next-intl"



function getCHANNELS() {
  return [
  { value: BILLING_CHANNELS.STRIPE, label: "Stripe", Logo: StripeLogo, logoClass: 'text-stripe-on-light dark:text-stripe-on-dark' },
  { value: BILLING_CHANNELS.SHOPIFY, label: "Shopify", Logo: ShopifyLogo, logoClass: 'text-shopify-on-light dark:text-shopify-on-dark' },
] as const
}

interface PlanChannelFilterProps {
  value: BillingChannel
  counts: Record<BillingChannel, number>
  onChange: (channel: BillingChannel) => void
}

export function PlanChannelFilter({ value, counts, onChange }: PlanChannelFilterProps) {

  const tUi = useTranslations("Billing.BillingPlanChannelFilter")
  const CHANNELS = getCHANNELS()


  return (
    <div role="group" aria-label={tUi("paymentChannel")} className="flex flex-wrap gap-2">
      {CHANNELS.map(({ value: channel, label, Logo, logoClass }) => {
        const selected = channel === value
        const count = counts[channel]
        return (
          <Button
            key={channel}
            type="button"
            variant="outline"
            size="sm"
            aria-pressed={selected}
            aria-label={tUi("value0Value1Value2", { value0: String(label), value1: String(count), value2: String(count === 1 ? 'plan' : 'plans') })}
            onClick={() => onChange(channel)}
            className={cn(
              'h-8 gap-2 rounded-full px-3 text-xs',
              selected && 'border-violet-600 bg-violet-50 text-violet-900 hover:bg-violet-100 hover:text-violet-900 dark:border-violet-400 dark:bg-violet-950/40 dark:text-violet-100 dark:hover:bg-violet-950/60 dark:hover:text-violet-100',
            )}
          >
            <Logo className={logoClass} />
            <span>{label}</span>
            <span className="rounded-full bg-muted px-1.5 py-px text-[10px] font-medium tabular-nums text-muted-foreground">{count}</span>
          </Button>
        )
      })}
    </div>
  )
}
